























import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)
@Component({
    components: {
        // Adding imported widgets here
    },
    name: 'Sample'
})
export default class Sample extends Vue {
    name:string = "";
    email:string = "";
    generateDocument(){
        let path = "https://api.messagehub.ca/sample?email=" + this.email + "&name=" + this.name;
        axios({
            url: path,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'file.docx');
            document.body.appendChild(link);
            link.click();
        });

    }
}
